import { render } from "./BaseStyle.vue?vue&type=template&id=779a17e9&ts=true"
import script from "./BaseStyle.vue?vue&type=script&lang=ts"
export * from "./BaseStyle.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__